import React from "react";
import { renderFields } from "../../UploadDetailsData";
import { THIRD_PARTY_FIELDS } from "../../UploadDetailsFields";
import indemnityForm from "../../../../assets/documents/Third Party Payment Indemnity form.pdf";
import "./index.scss";

const ThirdPartySection = ({
  show,
  formData,
  errors,
  handleChange,
  handleBlur,
  thirdPartyFile,
  handleThirdPartyFileChange,
  existingSignedFormFile = null,
  isDeficient = false,
}) => {
  if (!show) return null;

  // Determine what to show in the upload zone
  const hasNewFile = !!thirdPartyFile;
  const hasExistingFile = !!existingSignedFormFile?.filePath;
  const displayFileName = hasNewFile
    ? thirdPartyFile.name
    : hasExistingFile
      ? existingSignedFormFile.fileName ||
        existingSignedFormFile.filePath.split(/[\\/]/).pop()
      : null;

  return (
    <div className="tps-wrapper">
      {/* Alert */}
      <div className="tps-alert">
        <span className="tps-alert__icon">⚠️</span>
        <span>
          Trade name and beneficiary name do not match. Please provide third
          party payment details.
        </span>
      </div>

      {/* Step 1 — Download */}
      <div className="tps-step-card">
        <div className="tps-step-card__content">
          <span className="tps-step-label">STEP 1</span>
          <h4 className="tps-step-card__title">Third-party Declaration</h4>
          <p className="tps-step-card__desc">
            Download the letter head form, fill it with the required details and
            sign it.
          </p>
        </div>
        <a
          href={indemnityForm}
          download="Third Party Payment Indemnity Form.pdf"
          className="tps-download-btn"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
          </svg>
          Download
        </a>
      </div>

      {/* Step 2 — Fill fields */}
      <div className="tps-step-section">
        <span className="tps-step-label">STEP 2</span>
        <div className="form-grid">
          {renderFields(
            THIRD_PARTY_FIELDS,
            formData,
            errors,
            handleChange,
            handleBlur,
          )}
        </div>
      </div>

      {/* Step 3 — Upload */}
      <div className="tps-step-section">
        <span className="tps-step-label">STEP 3</span>
        <label className="tps-upload-label">
          Upload Signed Form <span className="tps-required">*</span>
        </label>
        {/* Red highlight wrapper when isSignedFormDef is true */}
        <div className={isDeficient ? "doc-deficient-wrap" : ""}>
          <label className="tps-upload-zone" htmlFor="thirdPartyDocument">
            <input
              id="thirdPartyDocument"
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              className="tps-upload-zone__input"
              onChange={(e) => handleThirdPartyFileChange(e.target.files[0])}
            />
            {displayFileName ? (
              <span className="tps-upload-zone__filename">
                {hasExistingFile && !hasNewFile && (
                  <span className="tps-upload-zone__existing-badge">
                    ✓ Uploaded
                  </span>
                )}
                {displayFileName}
              </span>
            ) : (
              <>
                <svg
                  className="tps-upload-zone__icon"
                  width="36"
                  height="36"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="16 16 12 12 8 16" />
                  <line x1="12" y1="12" x2="12" y2="21" />
                  <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
                </svg>
                <span className="tps-upload-zone__text">
                  Click to upload or drag &amp; drop
                </span>
                <span className="tps-upload-zone__hint">
                  PDF, JPG, PNG (Max 5MB)
                </span>
              </>
            )}
          </label>
          {isDeficient && (
            <span className="doc-deficient-label">
              ⚠ Deficiency — please re-upload
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ThirdPartySection;
